import { checkScroll } from "../helpers";
export function scrollManager(node) {
    let down = false;
    function handleMouseOver(e) {
        if (e.buttons === 1) {
            down = true;
        }
    }
    function handleMouseLeave() {
        down = false;
        if (cancelTimer) {
            cancelTimer();
        }
    }
    let cancelTimer = null;
    function handleMouseMove(e) {
        if (down) {
            if (cancelTimer) {
                cancelTimer();
            }
            cancelTimer = checkScroll(e, node);
        }
    }
    function handleMouseUp() {
        if (cancelTimer) {
            cancelTimer();
            cancelTimer = null;
        }
        down = false;
    }
    document.body.addEventListener("mousemove", handleMouseMove);
    document.body.addEventListener("mouseup", handleMouseUp);
    node.addEventListener("mousedown", handleMouseOver);
    node.addEventListener("mouseover", handleMouseOver);
    node.addEventListener("mouseleave", handleMouseLeave);
    return {
        destroy: () => {
            document.body.removeEventListener("mousemove", handleMouseMove);
            document.body.removeEventListener("mouseup", handleMouseUp);
            node.removeEventListener("mousedown", handleMouseOver);
            node.removeEventListener("mouseover", handleMouseOver);
            node.removeEventListener("mouseleave", handleMouseLeave);
        },
    };
}
//# sourceMappingURL=scrollManager.js.map